<a [href]="link" (click)="handleClick($event)" [class]="styleClass" > <i [class]="iconClass"></i> {{ title }}</a>
